import React from "react";

const SocialShare = [
  // {
  //   iconName: "facebook",
  //   link: "https://www.facebook.com/Soluciones-Tecnológicas-Alpha-111720803835686",
  // },
  {
    iconName: "linkedin",
    link: "https://www.linkedin.com/in/javier-villanueva-504b99210/",
  }
];
const Social = () => {
  return (
    <>
      <ul className="social">

        {SocialShare.map((val, i) => (

          <li key={i}>

            <a href={`${val.link}`} target="_blank" rel="noreferrer">

              <img
                className="svg"
                src={`/assets/img/svg/social/${val.iconName}.svg`}
                alt="social"
              />
              
            </a>

          </li>

        ))}

      </ul>
    </>
  );
};

export default Social;
